import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import EditButton from './EditButton';

const EditButtonLink = props => (
  <EditButton
    component={Link}
    target="_blank"
    rel="noopener noreferrer"
    {...props}
  />
);

EditButtonLink.propTypes = {
  to: PropTypes.string.isRequired,
};

export default EditButtonLink;
